import type { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { flowsValidator } from '../validation';
import Box from '@mui/material/Box';
import FilterSearch from './FilterSearch';
import FlowsGrid from './FlowsGrid';
import type { z } from 'zod';
import { SelectApplications } from 'components/common';
import { useListParams } from 'hooks';

type FormData = z.infer<typeof flowsValidator.schema>;

const Flows: FC = () => {
  const { q, apps } = useListParams();
  const formMethod = useForm<FormData>({
    resolver: flowsValidator.resolver,
    defaultValues: {
      q: q ?? '',
      apps: apps ? (apps as string[]) : undefined,
    },
  });

  return (
    <FormProvider {...formMethod}>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box
          sx={{ display: 'flex', width: '100%', flexDirection: 'row', gap: 2 }}
        >
          <Box sx={{ flex: 1, maxWidth: 400 }}>
            <FilterSearch placeholder={'Search by flow name'} name="q" />
          </Box>
          <Box sx={{ flex: 1, maxWidth: 400 }}>
            <SelectApplications name={'apps'} inputLabel={'Apps'} multiples />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            width: '100%',
            height: '100%',
            position: 'relative',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              height: '100%',
            }}
          >
            <FlowsGrid />
          </Box>
        </Box>
      </Box>
    </FormProvider>
  );
};

export default Flows;
